import { useEffect, useRef, useState } from 'react';
import {
  generateCacheKey,
  unableToGetProducts,
  productsFoundOnCache,
  startLoadingProducts,
  fetcher,
  productsFoundOnAPI,
  retrieveProductsFailed,
  IState,
  ICache,
} from './useMemoizedProducts.services';

const initialState: IState = { products: [], hasError: false, isLoading: true };

export const useMemoizedProducts = (
  skus?: string[],
  uf?: string,
  page?: number,
) => {
  const [state, setState] = useState<IState>(initialState);
  const cache = useRef<ICache>({});

  useEffect(() => {
    let cancel = false;
    const onUnmount = () => {
      cancel = true;
    };

    if (!skus || !skus.length) {
      unableToGetProducts()(setState);
      return onUnmount;
    }

    const cacheKey = generateCacheKey(skus, page, uf);

    if (cache.current[cacheKey]) {
      productsFoundOnCache(cache.current[cacheKey])(setState);
      return onUnmount;
    }

    startLoadingProducts()(setState);

    fetcher(skus, uf)
      .then((products) =>
        productsFoundOnAPI(cacheKey, products, cancel)(setState, cache),
      )
      .catch(() => retrieveProductsFailed(cancel)(setState));

    return onUnmount;
  }, [skus, page, uf]);

  return { ...state };
};
